// @flow
import type {Node} from 'react'
import React, {useMemo, useCallback} from 'react'
import Select from 'react-select'
import {compose, map, prop, sortBy, values} from 'ramda'

import FormGroup from 'components/ui/FormGroup'
import type {Option, Path, UpdateCallback} from 'components/proposals/types'
import type {Alert as ChangeAlert, Person} from '../../types'

const makeOption = ({name, databaseId}): Option => ({label: name, value: databaseId})

const makeOptions = compose(map(makeOption), sortBy(prop('name')), values)

type Props = {
  alert: ?ChangeAlert,
  availablePeople: Object,
  isReadonly: boolean,
  onChange: UpdateCallback,
  path: Path,
  person: ?Person,
}

function SelectPerson({alert, availablePeople, isReadonly, onChange, person, path}: Props): Node {
  const onSelect = useCallback((option: ?Option) => {
    const selectedPerson = availablePeople[option?.value]
    onChange(path, selectedPerson)
  }, [availablePeople, path, onChange])

  const options = useMemo(() => makeOptions(availablePeople), [availablePeople])
  const selectedOption = person ? options.find((option) => option.value === person.databaseId) : null

  const formAlert = isReadonly && !selectedOption ? alert : null

  return (
    <FormGroup
      alert={formAlert}
      className="select-person"
      id="elect-role-filler-person-select"
      label={I18n.t('proposals.role_elect.candidate')}
      small
      target="elect-role-filler-person"
    >
      <Select
        className="refinery-select"
        classNamePrefix="Select"
        isDisabled={isReadonly}
        inputId="elect-role-filler-person"
        noOptionsMessage={() => I18n.t('shared.no_results_found')}
        onChange={onSelect}
        options={options}
        placeholder={I18n.t('proposals.role_elect.select_person')}
        value={selectedOption}
      />
    </FormGroup>
  )
}

SelectPerson.defaultProps = {
  alert: null,
  person: null,
}

export default SelectPerson
